<template>
  <v-menu
    offset-y
    nudge-bottom="10"
    content-class="edit-menu">
    <template #activator="{ on }">
      <a
        class="lightBlue--text"
        v-on="on">
        Upload bulk product csv
        <v-icon
          color="lightBlue"
          small>
          mdi-download
        </v-icon>
      </a>
    </template>
    <v-card class="nav-card">
      <file-upload
        ref="uploadBulkCsv"
        v-model="files"
        :multiple="false"
        :drop="false"
        :drop-directory="false"
        input-id="uploadBulkCsv"
        @input-filter="inputFilter" />
      <p @click="downloadExampleCsv">
        <v-icon
          color="lightBlack"
          small>
          mdi-information-outline
        </v-icon>
        Download example template
      </p>
      <label for="uploadBulkCsv">
        <v-icon
          color="lightBlack"
          small>
          mdi-upload
        </v-icon>
        Upload csv file
      </label>
    </v-card>
  </v-menu>
</template>
<script>
import API from '@/services/graphql';
import FileUpload from 'vue-upload-component';
import {
  mapActions, mapMutations,
} from 'vuex';
export default {
  name: 'CollectionCreateProductBulk',
  components: {
    FileUpload,
  },
  props: {
    collection: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      files: [],
    };
  },
  watch: {
    files(val) {
      if (val?.length) {
        this.uploadFile();
      }
    },
  },
  methods: {
    ...mapActions(['handleError', 'declareAttachment', 'downloadFileByBlob']),
    ...mapActions('Collections', ['subscribeImportDocument']),
    ...mapMutations(['spinner', 'openSnackBar']),
    inputFilter(newFile, oldFile, prevent) {
      let val;
      if (newFile && !oldFile) {
        if (newFile.file && !newFile.file.type.includes('csv')) {
          this.handleError('Only CSV format is allowed to be downloaded');
          val = prevent();
        }
      } return val;
    },
    async uploadFile() {
      const { file, type, name: filename } = this.files[0];
      const { id: collection_id, libraryId: library_id } = this.collection;
      this.spinner(true);
      try {
        await this.subscribeImportDocument({
          collectionId: collection_id,
        });
        await this.declareAttachment({
          file: {
            file,
            type,
          },
          initialMetadata: {
            operation: 'import',
            collection_id,
            library_id,
          },
          filename,
        });
        this.openSnackBar({
          text: 'Bulk product csv has been successfully uploaded. The products will appear in the collection after a while',
        });
      } catch (err) {
        this.handleError(err);
      } finally {
        this.spinner(false);
      }
    },
    async downloadExampleCsv() {
      this.spinner(true);
      try {
        const { data } = await API.getTemplateUrl({
          filename: 'products_import_template.csv',
        });
        const link = data.response;
        this.handleDownload(link);
      } catch (err) {
        this.handleError(err);
      } finally {
        this.spinner(false);
      }
    },
    handleDownload(link) {
      const element = document.createElement('a');
      element.setAttribute('href', link);
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },
  },
};
</script>
<style scoped lang="scss">
</style>
